<template>
  <div class="exchange-detail detail-padding">
    <div class="spaceBetween">
      <p class="detail-title-1">Transfer History</p>
      <div class="search-form">
        <search-select @valChange="valChange($event,'type')" label="Type" :options="typeOptions"/>
      </div>
    </div>
    <div class="common-card">
      <el-table
        class="common-table"
        :data="tableList"
        v-loading="loading"
      >
        <el-table-column
          prop="data1"
          label="From"
          align="left"
        >
          <template slot-scope="{ row }">
            <div class="spaceLeft">
              <img v-if="row.type == 'mint'" class="td-type-img" src="@/assets/image/exchange/huan.png"/>
              <img v-if="row.type == 'mintBack'" class="td-type-img" src="@/assets/image/exchange/huigou.png"/>
              <div>
                <div>{{row.type == "mint" ? "UNIT to TCash" : "TCash to UNIT"}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="data1"
          label="To"
          align="left"
        >
          <template slot-scope="{ row }">
            <div class="spaceLeft">
              <img v-if="row.type == 'mint'" class="td-type-img" src="@/assets/image/exchange/huan.png"/>
              <img v-if="row.type == 'mintBack'" class="td-type-img" src="@/assets/image/exchange/huigou.png"/>
              <div>
                <div>{{row.type == "mint" ? "UNIT to TCash" : "TCash to UNIT"}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="lmtAmt"
          label="Token"
          align="right"
        >
          <template slot-scope="{ row }">
            - <big-number :number.sync="row.unit"/>
            <span class="td-word-sm">UNIT</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="lmtAmt"
          label="Time"
          align="center"
        >
          <template slot-scope="{ row }">
            {{moment(row.timestamp).format('YYYY.MM.DD')}}
          </template>
        </el-table-column>

        <el-table-column
          prop="lmtAmt"
          label="Status"
          align="right"
        >
          <template slot-scope="{ row }">

          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total.sync="queryParams.total"
        :page.sync="queryParams.page"
        :limit.sync="queryParams.pageSize"
        @pagination="getList()"
      />
    </div>
  </div>
</template>

<script>
import { exchangeList } from "@/api/ustn/exchange.js"
export default {
  components: {},
  data() {
    return {
      loading:false,
      searchParams:{},
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      tableList:[],
      typeOptions:[
        {value:"mint",label:"UNIT to TCash"},
        {value:"mintBack",label:"TCash to UNIT"}
      ]
    };
  },
  computed: {},
  methods: {
    valChange(data,prop){
      this.searchParams[prop] = data.value;
      this.getList();
    },
    getList(){
      this.loading = true;
      exchangeList({
        account:this.$store.getters.metaMaskObj.account,
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        ...this.searchParams,
      }).then(res => {
        this.tableList = res.result.data || [];
        this.queryParams.total = res.result.total || 0;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      })
    },
    refresh(){
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style scoped lang="scss">

.detail-padding {
  padding-left: 10%;
  padding-right: 10%;
}
.common-card {
  // background: #fff;
  border-radius: 0.16rem;
  padding: 0.32rem 0.24rem;
}

// .common-table{
//   ::v-deep  &.el-table{
//     font-size: 0.16rem;
//     .el-table__header-wrapper th{
//       background-color: #ffffff;
//       color: #AAAAAA;
//       height: 0.4rem;
//       font-size: 0.16rem;
//       font-weight: normal;
//     }
//     th.is-leaf, td{
//       border-bottom:none;
//     }
//     td{
//       font-size: 0.2rem;
//       font-weight: 400;
//       color: #1F1F1F;
//       line-height: 0.24rem;
//     }
//     &::before{
//       background: none;
//     }
//   }

// }
.exchange-detail {
  .detail-title-1 {
    margin-bottom: 0.24rem;
  }
  .td-type-img{
    width: 0.52rem;
    margin-right:0.16rem;
  }
}
.search-form{
  justify-content: end;
}
</style>
